import { WBox, WModal, WTypography } from '../../wrappers/wrapper';
import styles from './loading-modal.module.scss';
import CircularProgress from '@mui/material/CircularProgress';

interface LoadingModalProps {
  loading: boolean;
}

function LoadingModal({ loading }: LoadingModalProps) {
  return (
    <div className={styles['loading']}>
      <WModal
        open={loading}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <div className={styles['modal-container']}>
          <WBox className={styles['content']}>
            <WTypography id="modal-modal-title" variant="h6">
              Loading...
            </WTypography>
            <WTypography id="modal-modal-description">
              <CircularProgress />
            </WTypography>
          </WBox>
        </div>
      </WModal>
    </div>
  );
}

export default LoadingModal;
